import { useState, useEffect } from 'react';
import SEO from '../../components/base/SEO';
import Header from './components/Header';
import Hero from './components/Hero';
import DiagnosisSection from './components/DiagnosisSection';
import ResultSection from './components/ResultSection';
import TrustSection from './components/TrustSection';
import FAQ from './components/FAQ';
import Footer from './components/Footer';
import Breadcrumb from '../../components/feature/Breadcrumb';

export default function DiagnosisPage() {
  const [showScrollCTA, setShowScrollCTA] = useState(false);
  const [currentStep, setCurrentStep] = useState(0);
  const [answers, setAnswers] = useState<{
    annualFee?: string;
    priority?: string;
    occupation?: string;
  }>({});

  useEffect(() => {
    const handleScroll = () => {
      setShowScrollCTA(window.scrollY > 500);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleStartDiagnosis = () => {
    const diagnosisSection = document.getElementById('diagnosis-section');
    if (diagnosisSection) {
      diagnosisSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const handleAnswer = (question: string, answer: string) => {
    setAnswers(prev => ({ ...prev, [question]: answer }));
    setCurrentStep(prev => prev + 1);
  };

  const handleReset = () => {
    setAnswers({});
    setCurrentStep(0);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const breadcrumbItems = [
    { label: 'ホーム', path: '/' },
    { label: 'クレジットカード無料診断', path: '/diagnosis' }
  ];

  return (
    <>
      <SEO
        title="クレジットカード無料診断 | あなたに最適なカードが3分で見つかる"
        description="3つの質問に答えるだけで、あなたにぴったりのクレジットカードが見つかります。年会費・還元率・審査不安など、あなたの条件に合わせておすすめカードを提案。完全無料で診断できます。"
        keywords="クレジットカード診断,クレカ診断,おすすめクレジットカード,カード選び,無料診断"
        type="website"
      />
      <Header />
      <main>
        <Breadcrumb items={breadcrumbItems} />
        <Hero onStartDiagnosis={handleStartDiagnosis} />
        <DiagnosisSection
          currentStep={currentStep}
          answers={answers}
          onAnswer={handleAnswer}
        />
        {currentStep >= 3 && (
          <>
            <ResultSection answers={answers} onReset={handleReset} />
            <TrustSection answers={answers} />
          </>
        )}
        <FAQ />
      </main>
      <Footer />

      {/* スクロール追従CTA */}
      {showScrollCTA && (
        <button
          onClick={handleStartDiagnosis}
          className="fixed bottom-6 right-6 bg-red-600 text-white px-6 py-3 rounded-full shadow-lg hover:bg-red-700 transition-all duration-300 z-50 whitespace-nowrap flex items-center justify-center gap-2 w-14 h-14 md:w-auto md:h-auto"
          aria-label="無料診断スタート"
        >
          <i className="ri-questionnaire-line text-xl"></i>
          <span className="hidden md:inline">無料診断スタート</span>
        </button>
      )}
    </>
  );
}
